import { render, staticRenderFns } from "./AddAssociatedProject.vue?vue&type=template&id=4753fbf2"
import script from "./AddAssociatedProject.vue?vue&type=script&lang=js"
export * from "./AddAssociatedProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports